import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  CircularProgress,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import Footer from "../../component/footer";
import Nav from "../../component/nav/Navo";
import TeamStatus from "./TeamStatus";
import { blue, red } from "@mui/material/colors";

const FAQ = ({ setmymode, mode }) => {
  const [expanded, setExpanded] = useState(false);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await axios.get("https://sirius.runasp.net/api/FAQ");
        setFaqData(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching FAQ data", error);
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const teamData = {
    teamMembers: 10,
    projectsCompleted: 25,
    teamStatus: "active", // or 'inactive'
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Nav mode={mode} setmymode={setmymode} />
      <Container sx={{ paddingTop: "10rem" }}>
        <Typography variant="h3" sx={{ mb: 4, textAlign: "center" }}>
          Frequently Asked Questions
        </Typography>
        {faqData.map((faq, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            sx={{ mb: 2, border: mode === 'dark' ?"1px solid silver":  "1px solid lightCoral", borderRadius: 2 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />} 
              aria-controls={`panel${index}bh-content`}
              id={`panel${index}bh-header`}
              sx={{
                backgroundColor: expanded === `panel${index}` ? "lightCoral" : "transparent",
                // "&:hover": { backgroundColor:  },
              }}
            >
              <Typography variant="h6">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
      <TeamStatus teamData={teamData} />
      <Footer />
    </div>
  );
};

export default FAQ;
